module.exports = __webpack_public_path__ + "static/media/glb-icon.59c0a2f8.svg";